/*
 * @Author: your name
 * @Date: 2020-03-03 21:33:38
 * @LastEditTime: 2020-03-04 19:32:16
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /xkxy_front/src/store/modules/index.js
 */

  export default {
    state: {
      userid: '',
      openid: '',
      city: '',
      nickname: '',
      sex: '',
      province: ''
    },
    mutations: {
      setUserid (state, userid) {
        state.userid = userid
      },
      setOpenid (state, openid) {
        state.openid = openid
      },
      setCity (state, city) {
        state.city = city
      },
      setNickname (state, nickname) {
        state.nickname = nickname
      },
      setSex (state, sex) {
        state.sex = sex
      },
      setProvince (state, province) {
        state.province = province
      },
    },
    getters: {
      userid: state => state.userid,
      openid: state => state.openid,
      city: state => state.city,
      nickname: state => state.nickname,
      sex: state => state.sex,
      province: state => state.province
    },
    actions: {
        setUserid ({ commit }, { uid }) {
            commit('setUserid', uid)
            return
        },
        setOpenid ({ commit }, { openid }) {
            commit('setOpenid', openid)
            return
        },
        setCity ({ commit }, { city }) {
            commit('setCity', city)
            return
        },
        setNickname ({ commit }, { nickname }) {
            commit('setNickname', nickname)
            return
        },
        setSex ({ commit }, { sex }) {
            commit('setSex', sex)
            return
        },
        setProvince ({ commit }, { province }) {
            commit('setProvince', province)
            return
        },
        getUserInfo ({ state }) {
          return new Promise((resolve, reject) => {
            try {
              let info = {}
              info.uid = state.userid
              info.openid = state.openid
              info.nickname = state.nickname
              info.sex = state.sex
              info.city = state.city
              info.province = state.province
              resolve(info)
            } catch (error) {
              reject(error)
            }
          })
        }
  }
}


// WEBPACK FOOTER //
// ./src/store/module/user.js